import { IDeepCopy } from '@common/interfaces/i-deep-copy';

import { FilterDef } from './filter-def';

export class ViewStateFilter implements IDeepCopy<ViewStateFilter> {
    public filters: Array<FilterDef> = [];
    public relationshipFilters: Array<FilterDef> = [];
    public map: { [id: string]: FilterDef } = {};
    public groups: Array<FilterDef> = [];

    private _allFilters: Array<FilterDef> = [];

    private onChange: (value: any, prev: any) => any;
    public set OnChange(f: (v: any, p: any) => any) {
        this.onChange = f;
        for (const filter of this.filters) {
            filter.OnChange = (v, p) => {
                this.onChange(v, p);
            };
        }
        for (const relationshipFilter of this.relationshipFilters) {
            relationshipFilter.OnChange = (v, p) => {
                this.onChange(v, p);
            };
        }
    }

    constructor() {}

    public push(f: FilterDef) {
        if (f.IsRelationship) {
            this.relationshipFilters.push(f);
        } else {
            this.filters.push(f);
        }
        this._allFilters.push(f);
        if (!f.NotUsed) {
            if (f.IsRequired) {
                this.requiredFilters.push(f);
            } else {
                this.optionalFilters.push(f);
            }
        }
        if (this.OnChange) {
            f.OnChange = (v, p) => {
                this.OnChange(v, p);
            };
        }
        this.map[f.ID] = f;
    }

    public requiredFilters: Array<FilterDef> = [];

    public optionalFilters: Array<FilterDef> = [];

    public get allFilters(): Array<FilterDef> {
        return [...this._allFilters];
    }

    public toJSON() {
        return JSON.stringify(this.map);
    }

    public deepCopy(): ViewStateFilter {
        const ret = new ViewStateFilter();
        for (const f of this.filters) {
            ret.push(f.deepCopy());
        }
        for (const g of this.groups) {
            ret.groups.push(g.deepCopy());
        }
        for (const rel of this.relationshipFilters) {
            ret.push(rel.deepCopy());
        }
        ret.requiredFilters = ret.allFilters.filter(item => {
            return !!this.requiredFilters.find(filter => {
                return filter.ID === item.ID;
            });
        });
        ret.optionalFilters = ret.allFilters.filter(item => {
            return !!this.optionalFilters.find(filter => {
                return filter.ID === item.ID;
            });
        });
        return ret;
    }

    public onFilterStateChange(fromRequired: boolean) {
        if (fromRequired) {
            const ids: Array<string> = this.requiredFilters.map(f => f.ID);
            this.requiredFilters.forEach(f => {
                this.map[f.ID].IsRequired = true;
                this.map[f.ID].IsOptional = false;
                this.map[f.ID].NotUsed = false;
            });
            this.allFilters.forEach(f => {
                if (ids.indexOf(f.ID) === -1) {
                    f.IsRequired = false;
                    if (!f.IsOptional) f.NotUsed = true;
                }
            });
        } else {
            const ids: Array<string> = this.optionalFilters.map(f => f.ID);
            this.optionalFilters.forEach(f => {
                this.map[f.ID].IsRequired = false;
                this.map[f.ID].IsOptional = true;
                this.map[f.ID].NotUsed = false;
            });
            this.allFilters.forEach(f => {
                if (ids.indexOf(f.ID) === -1) {
                    f.IsOptional = false;
                    if (!f.IsRequired) f.NotUsed = true;
                }
            });
        }
    }
}
